import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetMakeToOrderPlanPreviewQueryVariables = Types.Exact<{
  input: Types.MakeToOrderPlanPreviewInput;
}>;


export type GetMakeToOrderPlanPreviewQuery = { __typename?: 'Query', makeToOrderPlanPreview: { __typename?: 'MakeToOrderPlanPreviewPayload', fills?: Array<{ __typename?: 'MakeToOrderPlanPreviewFill', orderId: string, orderNumber: string, orderLineId: string, itemName: string, productionLotId: string, lotNumber: number, readyWeek: Types.TDateISO, quantity: number, orderedQuantity: number }> | null, shortfalls?: Array<{ __typename?: 'MakeToOrderPlanPreviewShortfall', orderId: string, orderNumber: string, neededQuantity: number, filledQuantity: number, shortQuantity: number }> | null, groups?: Array<{ __typename?: 'MakeToOrderPlanPreviewGroup', productionItemId: string, productionItemName: string, readyWeek: Types.TDateISO, customerId?: string | null, lotQuantity: number, lines: Array<{ __typename?: 'MakeToOrderPlanPreviewLine', orderId: string, orderNumber: string, customerName: string, orderLineId: string, itemName: string, quantity: number, expectedDeliveryDate: Types.TDateISO }> }> | null, skipped?: Array<{ __typename?: 'MakeToOrderPlanPreviewSkip', orderId: string, orderNumber?: string | null, orderLineId?: string | null, reason: Types.MakeToOrderPlanSkipReason, message: string }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const GetMakeToOrderPlanPreviewDocument = new TypedDocumentString(`
    query GetMakeToOrderPlanPreview($input: MakeToOrderPlanPreviewInput!) {
  makeToOrderPlanPreview(input: $input) {
    fills {
      orderId
      orderNumber
      orderLineId
      itemName
      productionLotId
      lotNumber
      readyWeek
      quantity
      orderedQuantity
    }
    shortfalls {
      orderId
      orderNumber
      neededQuantity
      filledQuantity
      shortQuantity
    }
    groups {
      productionItemId
      productionItemName
      readyWeek
      customerId
      lotQuantity
      lines {
        orderId
        orderNumber
        customerName
        orderLineId
        itemName
        quantity
        expectedDeliveryDate
      }
    }
    skipped {
      orderId
      orderNumber
      orderLineId
      reason
      message
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMakeToOrderPlanPreview: build.query<GetMakeToOrderPlanPreviewQuery, GetMakeToOrderPlanPreviewQueryVariables>({
      query: (variables) => ({ document: GetMakeToOrderPlanPreviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMakeToOrderPlanPreviewQuery, useLazyGetMakeToOrderPlanPreviewQuery } = injectedRtkApi;
